<template>
  <div class="prescription-page">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <div class="breadcrumb-content">
        <span class="active">提交问诊信息</span>
        <icon name="arrow" />
        <span>医生接诊开方</span>
        <!-- <icon name="arrow" />
        <span>图文交流</span> -->
        <icon name="arrow" />
        <span>支付订单</span>
      </div>
    </div>

    <div class="address-item" @click="selectAddr" v-if="false">
      <div class="address-content">
        <i class="iconfont icon-shdz" />
        <div class="address-info" v-if="addressInfo.addressId">
          <h3 class="address-name">
            <span>{{ addressInfo.addressee }}</span>
            <span class="address-phone">{{ addressInfo.phone }}</span>
          </h3>
          <p class="address-area">{{ showArea(addressInfo) }}</p>
        </div>
        <div class="address-info" v-else>
          <h3 class="address-area">请选择地址</h3>
        </div>
        <div class="address-status">
          <p class="view-details"><icon name="arrow" /></p>
        </div>
      </div>
    </div>
    <!-- 用药人信息 -->
    <div class="user-info card-panel">
      <div class="panel-header">
        <h3>用药人</h3>
        <div class="one-click" @click="showMedicineList = true">
          <icon name="plus" />
          <span>选择/新建用药人</span>
          <icon name="arrow" />
        </div>
      </div>
      <div class="form-content" v-if="selectedMedicine">
        <div class="user-info-row">
          <span class="label">真实姓名</span>
          <span class="value">{{ selectedMedicine.name }}</span>
        </div>
        <div class="user-info-row">
          <span class="label">手机号</span>
          <span class="value">{{ hideMiddleChars(selectedMedicine.phone) }}</span>
        </div>
        <div class="user-info-row">
          <span class="label">身份证</span>
          <span class="value">{{ hideMiddleChars(selectedMedicine.idCard) }}</span>
        </div>
        <!-- <div class="user-info-row">
          <span class="label">健康信息</span>
          <span class="value">{{ selectedMedicine.health }}</span>
        </div> -->
        <div class="user-info-row">
          <span class="label">关系</span>
          <span class="tag">{{ selectedMedicine.relTag }}</span>
        </div>
      </div>
    </div>

    <!-- 药品和对应疾病选择 -->
    <div class="product-disease-list card-panel" v-if="orderInfo.sum">
      <h3>
        <span class="required">*</span>选择线下已确诊疾病
        <span style="font-size: 12px; color: #ee0a24; margin-left: 4px;">（每个药品至少选择一种）</span>
      </h3>

      <div class="product-disease-item" v-for="product in products" :key="product.id">
        <div class="product-disease-content ">
          <!-- 药品信息 -->
          <div class="product-content">
            <div class="item-img">
              <van-image fit="cover" :src="product.goodsIcon" />
            </div>
            <div class="product-details">
              <drugTag :product="product" />
              <p class="product-description">{{ product.goodsFunction }}</p>
              <div class="product-foot">
                <span class="product-price"
                  ><pointPrice v-if="false" :product="product" />￥{{ product.salePrice }}</span
                >
                <!-- <stepper
                  v-model="product.number"
                  theme="round"
                  button-size="22"
                  disable-input
                  min="1"
                  max="99"
                  @change="refreshInfo"
                /> -->
                <span>x{{ product.number }}</span>
              </div>
            </div>
          </div>

          <!-- 对应疾病选择 -->
          <div class="disease-info">
            <div class="disease-tags">
              <span
                v-for="disease in product.diseases"
                :key="disease.id"
                :class="['disease-tag', { active: product.selectedDiseases.includes(disease.diseaseId) }]"
                @click="toggleDisease(disease.diseaseId, product)"
              >
                {{ disease.diseaseName }}
              </span>
            </div>
            <!-- 手动输入疾病（用于系统未录入时） -->
            <van-field
              v-if="product.medicineType === 'RX'"
              v-model="product.manualDiseaseName"
              label="手动输入疾病："
              placeholder="可自行输入疾病"
              clearable
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 处方/病历/检查报告 -->
    <div class="upload-panel card-panel">
      <h3>处方/病历/检查报告<span class="subtitle">（选填，最多5张）</span></h3>
      <div class="upload-area">
        <van-uploader v-model="fileList" :max-count="5" :after-read="afterRead">
          <div class="upload-button">
            <icon name="plus" />
          </div>
        </van-uploader>
      </div>
    </div>

    <!-- 底部固定区域 -->
    <div class="bottom-fixed">
      <!-- 用药人承诺 -->
      <div class="agreement">
        <van-checkbox v-model="agreement" shape="square">
          我确认已确诊此疾病并使用过该药，且无过敏、无相关禁忌症和不良反应
        </van-checkbox>
      </div>

      <!-- 底部按钮 -->
      <div class="bottom-button">
        <van-button type="danger" block :disabled="!agreement" @click="submitOrder">
          免费问诊开方
        </van-button>
      </div>
    </div>

    <!-- 用药人选择弹框 -->
    <van-popup v-model="showMedicineList" position="bottom" :style="{ height: '80%', backgroundColor: '#f7f8fa' }">
      <medicine-list @select="handleMedicineSelect" />
    </van-popup>
  </div>
</template>

<script>
import { Field, Button, Checkbox, Uploader, Icon, Image as VanImage, Popup } from 'vant';
import MedicineList from '@/views/mall/medicine';
import services from '@/service';
import drugTag from '@/components/drugTag';
import { mapGetters } from 'vuex';
import { hideMiddleChars } from '@/lib/utils';

export default {
  name: 'mallPrescription',
  components: {
    drugTag,
    [Field.name]: Field,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Uploader.name]: Uploader,
    // Stepper,
    VanImage,
    Icon,
    [Popup.name]: Popup,
    MedicineList
  },
  data() {
    return {
      hideMiddleChars,
      products: [],
      orderInfo: {},
      orderId: null,
      quantity: 1,
      agreement: false,
      fileList: [],
      selectedDiseases: [],
      async afterRead(file) {
        const formData = new FormData();
        formData.append('file', file.file);
        const res = await services.common.fileUpload(formData);
        file.url = res.data.url;
      },
      showMedicineList: false,
      selectedMedicine: null,
      // Mock数据
      drugInfo: {
        id: 1,
        name: '[可威]磷酸奥司他韦颗粒 15mg*10袋 1盒装 25...',
        spec: '15mg*10袋',
        price: '25.50',
        image: 'https://img14.360buyimg.com/n0/jfs/t1/264430/26/21071/93930/67b42146Fdfaa68b9/3b0f88242c0edec9.jpg'
      },
      diseases: [
        { id: 1, name: '已知病毒的流行性感冒' },
        { id: 2, name: '病毒性感冒' },
        { id: 3, name: '甲型H1N1流感' },
        { id: 4, name: '预防流感' },
        { id: 5, name: '乙型流感' }
      ]
    };
  },
  computed: {
    ...mapGetters(['openId', 'addressInfo'])
  },
  methods: {
    showArea(item) {
      return `${item.province} ${item.city} ${item.district} ${item.address}`;
    },
    selectAddr() {
      if (this.hasOrder) return;
      this.$router.push({
        name: 'mallMyAddress',
        query: {
          isSelect: true
        }
      });
    },
    handleMedicineSelect(medicine) {
      this.selectedMedicine = medicine;
      this.showMedicineList = false;
    },
    toggleDisease(id, product) {
      const index = product.selectedDiseases.indexOf(id);
      if (index === -1) {
        if (product.selectedDiseases.length >= 3) {
          this.$toast('每个药品最多只能选择3个疾病');
          return;
        }
        product.selectedDiseases.push(id);
      } else {
        product.selectedDiseases.splice(index, 1);
      }
    },
    async createOrder() {
      if (!this.addressInfo.addressId) {
        return this.$toast('请选择地址');
      }
      this.$store.dispatch('addLoading');
      const params = {
        addressCityName: this.addressInfo.city,
        addressDetail: this.addressInfo.address,
        addressMobile: this.addressInfo.phone,
        addressName: this.addressInfo.addressee,
        addressProvinceName: this.addressInfo.province,
        addressRegionName: this.addressInfo.district,
        clinicId: this.$store.getters.curClinicId,
        clinicName: this.$store.getters.curClinicName,
        // remark: this.orderInfo.remark,
        consumptionPoints: 0,
        membershipPoints: 0,
        mallOrderDetailAoList: this.products
          .filter(i => i.number > 0)
          .map(i => {
            return {
              goodsId: i.goodsId,
              number: i.number
            };
          })
      };
      const orderRes = await services.mall.createServiceOrder(params);
      this.orderId = orderRes.data.mallOrderId;
      // this.mallOrderId = orderRes.data.mallOrderId;
      // this.payAmount = orderRes.data.payAmount;
      this.$store.dispatch('subLoading');
    },
    async submitOrder() {
      // 检查处方药是否选择了至少一种疾病（含手动输入）
      const unselectedProduct = this.products.find(product => {
        if (product.medicineType !== 'RX') return false;
        const hasSelected = Array.isArray(product.selectedDiseases) && product.selectedDiseases.length > 0;
        const hasManual = !!(product.manualDiseaseName && product.manualDiseaseName.trim());
        return !(hasSelected || hasManual);
      });
      if (unselectedProduct) {
        this.$toast('处方药至少需要选择一种疾病');
        return;
      }
      if (!this.selectedMedicine) {
        this.$toast('请选择用药人');
        return;
      }

      // await this.createOrder();

      const params = {
        // 积分商城wx8e6447c6d6718fe1
        appId: 'wx8e6447c6d6718fe1',
        // burl: `${process.env.VUE_APP_REDIRECT_URI}${this.$route.fullPath}`,
        burl: ``,
        curl: `${process.env.VUE_APP_REDIRECT_URI}/mall-my-order?rxSuccess=1`,
        diseaseInfos: this.products.reduce((acc, product) => {
          const selectedDiseases = product.diseases
            .filter(disease => product.selectedDiseases.includes(disease.diseaseId))
            .map(disease => ({
              diseaseId: disease.diseaseId,
              diseaseName: disease.diseaseName
            }));
          const manualDisease =
            product.manualDiseaseName && product.manualDiseaseName.trim()
              ? [{ diseaseId: null, diseaseName: product.manualDiseaseName.trim() }]
              : [];
          return [...acc, ...selectedDiseases, ...manualDisease];
        }, []),
        orderId: this.orderId,
        patientRelId: this.selectedMedicine.patientRelId,
        picInfos: this.fileList.map(i => {
          return {
            picUrl: i.url
          };
        }),
        sourceType: 1
      };
      const res = await services.mall.rxInquiry(params);
      const url = `${res.data}&headColor=289afc`;
      localStorage.setItem('mallPrescriptionUrl', url);
      localStorage.setItem('mallPrescriptionOrderId', this.orderId);

      this.$router.replace({
        name: 'mallMyOrder'
      });
    },
    refreshInfo() {
      this.getOrderDetail();
    },
    async getOrderDetail() {
      const res = await services.mall.getServiceOrder(this.orderId);
      this.orderInfo = res.data;
      this.products = res.data.mallOrderDetailVoList.map(e => {
        return {
          ...e,
          diseases: [],
          selectedDiseases: [],
          manualDiseaseName: ''
        };
      });
      this.diseaseList();
    },
    async diseaseList() {
      const params = {
        drugsIds: this.products.map(e => e.goodsId)
      };
      const res = await services.mall.diseaseList(params);
      this.products.forEach(product => {
        product.diseases = res.rows.filter(e => product.goodsId === e.drugsId);
      });
    }
  },
  mounted() {
    const data = JSON.parse(window.atob(this.$route.query.state) || {});
    // this.products = data.products;
    this.orderId = data.mallOrderId;
    this.getOrderDetail();
  }
};
</script>

<style lang="scss" scoped>
.address-item {
  border-bottom: 1px solid $bordercolor;
  background: #fff;
  padding: $tb $lr;
  // margin: $tb $lr;
  border-radius: $radius;
  overflow: hidden;
  position: relative;
  box-shadow: $box-shadow1;
}

.address-content {
  display: flex;
  align-items: center;

  .icon-shdz {
    font-size: 32px;
    margin-right: $lr;
    color: transparent; /* 将iconfont的颜色改为透明 */
    -webkit-background-clip: text; /* 将背景图的绘画仅作用在文字上 */
    background-image: $btnbg;
  }
}

.address-image {
  width: 60px;
  height: 60px;
  overflow: hidden;
  border-radius: 5px;
  margin-right: $lr;
}

.address-avatar {
  width: 100%;
  height: auto;
}

.address-info {
  flex: 1;
}

.address-name {
  margin-bottom: $tb;
  font-size: $size2;
  font-weight: 500;
  color: $black1;
  .address-phone {
    font-size: $size4;
    margin: 0 $lr;
  }
}

.address-area {
  color: $gray2;
  font-size: $size4;
  line-height: 20px;
}

.prescription-page {
  background: #f7f8fa;
  min-height: 100vh;
  padding-bottom: 120px;

  .breadcrumb {
    background: #fff;
    padding: 12px 0;
    border-bottom: 1px solid #f5f5f5;
    // position: sticky;
    top: 0;
    z-index: 100;

    .breadcrumb-content {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #999;

      span {
        margin: 0 4px;

        &.active {
          color: #333;
          font-weight: 500;
        }
      }

      .van-icon {
        font-size: 12px;
        color: #999;
      }
    }
  }

  .drug-info {
    background: #fff;
    padding: 16px;
    margin: 12px;
    border-radius: 8px;
    display: flex;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

    .drug-image {
      width: 80px;
      height: 80px;
      margin-right: 12px;
      border-radius: 4px;
      overflow: hidden;
    }

    .drug-detail {
      flex: 1;

      .drug-name {
        font-size: 15px;
        color: #333;
        margin-bottom: 8px;
        line-height: 1.4;
      }

      .drug-spec {
        font-size: 13px;
        color: #999;
        margin-bottom: 12px;
      }

      .drug-price {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .price {
          font-size: 18px;
          color: #ee0a24;
          font-weight: 500;
        }
      }
    }
  }

  .card-panel {
    background: #fff;
    margin: 12px;
    padding: 16px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

    h3 {
      font-size: $size5;
      color: #333;
      margin-bottom: 16px;
      font-weight: 500;

      .required {
        color: #ee0a24;
        margin-right: 4px;
      }

      .subtitle {
        font-size: 13px;
        color: #999;
        margin-left: 4px;
        font-weight: normal;
      }
    }
  }

  .user-info {
    .panel-header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      h3 {
        margin-bottom: 0;
      }

      .one-click {
        display: flex;
        align-items: center;
        color: $appcolor;
        font-size: 13px;
        cursor: pointer;

        .van-icon {
          font-size: 14px;
          margin-right: 4px;

          &:last-child {
            margin-right: 0;
            margin-left: 4px;
          }
        }
      }
    }

    .form-content {
      margin-top: $tb;

      .user-info-row {
        display: flex;
        align-items: center;
        padding: 6px 0;
        font-size: 13px;

        .label {
          width: 70px;
          color: #666;
        }

        .value {
          flex: 1;
          color: #333;
          word-break: break-all;
        }

        .tag {
          padding: 2px 8px;
          border-radius: 10px;
          font-size: 12px;
          color: #4a90e2;
          background: rgba(74, 144, 226, 0.1);
        }
      }
    }
  }

  .disease-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;

    .disease-tag {
      padding: 8px 16px;
      border-radius: 4px;
      font-size: 14px;
      color: #666;
      background: #f5f5f5;
      transition: all 0.1s;
      cursor: pointer;

      &.active {
        background: rgba(74, 144, 226, 0.1);
        color: #4a90e2;
      }

      &:active {
        opacity: 0.8;
      }
    }
  }

  .upload-panel {
    .upload-area {
      .upload-button {
        width: 80px;
        height: 80px;
        background: #f5f5f5;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;

        .van-icon {
          font-size: 24px;
          color: #999;
        }
      }
    }
  }

  .bottom-fixed {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    padding: 12px 16px;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);

    .agreement {
      margin-bottom: 12px;
      padding: 0 4px;

      ::v-deep .van-checkbox__label {
        color: #666;
        font-size: 13px;
        line-height: 1.4;
      }
    }

    .bottom-button {
      .van-button {
        height: 44px;
        border-radius: 22px;
        font-size: 16px;
      }
    }
  }
}

.product-disease-list {
  // margin: 12px;

  .product-disease-item {
    // margin-bottom: 12px;
    border-top: 1px solid #f5f5f5;
    padding: $tb 0;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.disease-title {
  margin-bottom: 0;
}

.product-disease-content {
  .product-content {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }

  .disease-info {
    // border-top: 1px solid #f5f5f5;
    // padding-top: 16px;
  }
}

.price-info {
  box-shadow: $box-shadow1;
  border-radius: 5px;
  background: #fff;
  margin: $tb 0;
  padding: $tb $lr;
  font-size: $size5;
  color: $gray1;

  .price-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: right;
    > :first-child {
      color: $gray2;
    }
    &:not(:last-child) {
      margin-bottom: $tb;
    }
    .price {
      color: $red1;
      font-weight: 600;
      margin-left: $lr;
    }
  }

  .price-total {
    font-size: $size2;
  }
}

.product-item {
  flex: 1;
  border-bottom: 1px solid $bordercolor;
  padding: $tb 0;
  margin: 0 $lr;
  &:last-child {
    border: none;
  }
}

.product-content {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  background: #fff;
  border-radius: 8px;
  // padding: 16px;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.item-img {
  width: 50px;
  height: 50px;
  margin-right: 12px;
  border-radius: $radius;
  overflow: hidden;

  .van-image {
    width: 100%;
    height: 100%;
  }
}

.product-details {
  position: relative;
  flex: 1;
  .product-foot {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // padding-right: $lr;
  }

  .del-icon {
    position: absolute;
    right: 3px;
    top: 0px;
  }
}

.product-name {
  color: $black1;
  // margin-bottom: $tb;
  font-size: $size4;
  width: 90%;
}

.product-description {
  color: $gray2;
  margin-bottom: $tb;
  font-size: $size4;
  @include hiddenText();
}

.product-price {
  // font-weight: 600;
  font-size: $size5;
  color: $black1;
}

.van-submit-bar {
  bottom: $tabbarHeight;
}
.cart-icon {
  font-size: 24px;
  &.active {
    color: $appcolor;
  }
}
// 全局样式优化
// ::v-deep {
//   .van-field {
//     padding: 6px 12px;

//     &__label {
//       width: 60px;
//       font-size: 13px;
//     }

//     &__control {
//       font-size: 13px;
//     }
//   }

//   .van-uploader {
//     .van-uploader__wrapper {
//       padding: 4px;
//     }
//   }

//   .van-checkbox {
//     .van-checkbox__icon {
//       font-size: 16px;
//     }
//   }

//   .van-stepper {
//     .van-stepper__input {
//       width: 32px;
//       height: 28px;
//       background: #f5f5f5;
//     }

//     .van-stepper__minus,
//     .van-stepper__plus {
//       width: 28px;
//       height: 28px;
//       background: #f5f5f5;
//     }
//   }
// }
</style>
